import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';
import { DataService } from '../../shared/services/data.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { LoaderService } from '../services/loader.service';
import { finalize } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class BasketService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
  private dataService: DataService, private route: Router, private httpClient: HttpClient,private loaderService: LoaderService) { }
  local_contactId:any = "";

  GetBasket(id: any): void {
    if (id== "null") {
      this.route.navigate(['/']);
    }
    this.loaderService.show();
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Basket/GetBasket?id=` + id;
    this.dataService.get(url, id)
    .pipe(finalize(() => this.loaderService.hide()))
    .subscribe(
      data => {
        return data.result
      },
      errorResponse => {
        this.route.navigate(['/']);
      }
    );
  }

  createBasket(product: any) {
    if (product != null) {
      let basket = {
        "ip": "",
        "contactId": this.local_contactId,
        "typeLivraison":"simple",
        "items": [
          {
            "codeOffreCRM": product.codeOffreCRM,
            "priceGuideFile": product.priceGuideFile,
            "recapContrat": product.recapContrat,
            "productId": product.id,
            "productName": product.libelle,
            "price": product.maxTarif,
            "price_range": null,
            "productType": null,
            "operateur": product.operators,
            "isOption5G": false,
            "isNewNumber": false,
            "phoneNumber": "",
            "newPhoneNumberList": "",
            "type": "NP",
            "simType": "sim",
            "portabilityDate": null,
            "rio": null,
            "inPack": false,
            "inclus5G": false,
            "is5GAuthorized": false,
            "fixedPrice": false,
            "promotionValidityPeriod": null,
            "fonctionalites": product.fonctionalites,
            "simPrice": product.simPrice,
            "maxVolume": product.maxVolume,
            "maxTarif": product.maxTarif
          }
        ]
      };
      
      if (isPlatformBrowser(this.platformId)) {
        this.local_contactId =localStorage.getItem('contactId');
        const gtmTag = {
          event: "add_to_cart",
          ecommerce: {
             currency: "EUR",
             value: product.maxTarif,
              items: [
                  {
                      item_id: product.id,
                      item_name: "Forfait "+ product.libelle + " "+ product.operators,
                      item_category: product.libelle,
                      item_category2: product.operators,
                      discount: 0,
                      price: product.maxTarif,
                      quantity: 1
                  }
              ]
          }
        };
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push(gtmTag);
        const gtmTag2 = {
          event: "view_cart",
          ecommerce: {
            currency: "EUR",
            value: product.maxTarif,
            items: [
              {
                 item_id: product.id,
                 item_name: "Forfait "+ product.libelle + " "+ product.operators,
                 item_category: product.libelle,
                 item_category2: product.operators,
                 discount: 0,
                 price: product.maxTarif
              }
            ]
          }
        };
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push(gtmTag2); 
      }
      if (this.local_contactId == null || this.local_contactId == "null") {
        this.local_contactId = "";
      }
      this.loaderService.show();
      basket.contactId = this.local_contactId;
      const isSSR = isPlatformServer(this.platformId);
      const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
      let url = `${apiUrl}/Basket/CreateBasket`;
      this.dataService.post(url, basket)
      .pipe(
        finalize(() => {
          this.loaderService.hide();
          if (isPlatformBrowser(this.platformId)) {
            this.route.navigate(['/panier', localStorage.getItem('contactId')]);
          }
        }) 
      ).subscribe(
        data => {
          if (this.local_contactId == "" || this.local_contactId == null) {
            if (isPlatformBrowser(this.platformId)) {
              localStorage.setItem("contactId", data.result);
            }
          }
           
          this.route.navigate(['/panier', data.result]);
          return data;
        },
        errorResponse => {
          this.route.navigate(['/']);
        }
      );
    }
  }
  verifPhoneNumber(num: any, captchaCode:any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Order/VerifnumParrain?num=` + num + '&captchaCode=' + captchaCode;
    return this.dataService.get(url, num);
  }
  checkValidOrder(customerId: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Order/checkValidOrder?customerId=` + customerId;
    return this.dataService.get(url, customerId);
  }
  verifCodeParrainage(code: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Order/VerifCode?code=` + code;
    return this.dataService.get(url, code);
  }
  updateBasket(basket: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    if (basket != null) {
      this.loaderService.show();
      let url = `${apiUrl}/Basket/UpdateBasket`;
      this.dataService.post(url, basket)
      .pipe(
    finalize(() => this.loaderService.hide())
    ).subscribe(
        data => {
          if (isPlatformBrowser(this.platformId)) {
              localStorage.setItem("counter", basket.items.length.toString());
            }
          return data;
        },
        errorResponse => {
        }
      );
    }
  }

  saveBasket(basket: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
      ? `${environment.apiUrlLocal}`
      : `${environment.apiUrl}`;
    this.loaderService.show();
    return this.dataService
      .post(`${apiUrl}/Basket/UpdateBasket`, basket)
      .pipe(finalize(() => this.loaderService.hide()));
  }
  updateDocapostBasket(basket: any,idBasket:any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    if (basket != null) {
      this.loaderService.show();
      let url = `${apiUrl}/Basket/UpdateBasket`;
      this.dataService.post(url, basket)
      .pipe(
      finalize(() => this.loaderService.hide())
      ).subscribe(
        data => {
          this.route.navigate(['/verifDocaposte', idBasket]);
        },
        errorResponse => {
        }
      );
    }
  }

  getBasketByUrl(urlName: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    if (urlName== "null") {
      this.route.navigate(['/']);
      return null;
    }
    let url = `${apiUrl}/Basket/GetBasket?id=` + urlName;
    return this.httpClient.get(url);
  }

  GetValidBasket(urlName: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    if (urlName== "null") {
      this.route.navigate(['/']);
      return null;
    }
    let url = `${apiUrl}/Basket/GetValidBasket?id=` + urlName;
    return this.httpClient.get(url);
  }
  initPayment(urlName: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Order/initPaymentCB?basketId=` + urlName;
    return this.dataService.post(url, "");
  }
  getRecapOrder(urlName: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Order/getRecapOrder?basketId=` + urlName;
    return this.dataService.post(url, "");
  }
  getCustomerById() {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Customer/GetCustomerBrefInfoById`;
    return this.dataService.get(url);
  }
  getActiveProductById(id: any) {
     const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Product/GetDetail?id=` + id;
    return this.httpClient.get(url);
  }
  updateIbanBic(order: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Customer/updateIBCustumer`;
    return this.dataService.putWithId(url, order);
  }
  updateBankCustomer(order: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Customer/updateBankCustomer`;
    return this.dataService.putWithId(url, order);
  }
  createOrder(order: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Order/CreateOrderV2`;
    return this.dataService.post(url, order);
  }
  syncOrderItems(order: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Order/SyncOrderItems`;
    return this.dataService.post(url, order);
  }
  verifVivant(idBasket:any){
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Customer/verifDocaposte?idBasket=`+idBasket ;
    if (isPlatformBrowser(this.platformId) && window.location.hostname.endsWith('youprice.fr')) {
      const browserCallbackUrl = `${window.location.origin}/paiement/${idBasket}?docaposte=True`;
      url += `&browserCallbackUrl=${encodeURIComponent(browserCallbackUrl)}`;
    }
    return this.dataService.post(url,"");
  }

  getDocaposteStatus(){
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Customer/GetDocaposteStatus`;
    return this.dataService.get(url);
  }

  checkValidity(checkDto:any){
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Product/checkValidity`;
    return this.dataService.post(url,checkDto);
  }

  deleteBasket(idbasket: any) {
    const isSSR = isPlatformServer(this.platformId);
    const apiUrl = isSSR
    ? `${environment.apiUrlLocal}`
    : `${environment.apiUrl}`;
    let url = `${apiUrl}/Basket/DeleteteBasket?id=`+idbasket;
    if (isPlatformBrowser(this.platformId)) {
                localStorage.setItem("counter", '0');
              }
    return this.dataService.post(url, "")
  }
}

export interface BasketItem {
  operators: string;
  isOption5G: boolean;
  prix?: string;
  gigas?: string;
  reseau?: string;
  urlName?: string;
  id?: string;
  classification?: string;
  promo?: boolean;
  simPrice?: number;
  maxVolume?: number;
  maxTarif?: number;
  fonctionalites?: string;
  ypBasketId?: string;
  type?: string;
  simType?: string;
  productId?: string;
  portabilityDate?: string;
  productName?: string;
  rio?: string;
}

export interface Basket {
  items: BasketItem[];
  agent: string;
  contactId: string;
  createDate: string;
  customertId: number;
  deleteDate: string;
  id: string;
  ip: string;
  isDeleted: string;
  step: string;
  updateDate: string;
  codeParrainegeId: string;
  codeParrainegeName: string;
  numParrain: string;
}
